import { createSelector } from 'reselect'
import { get } from 'lodash'
import { bulkForm } from 'constants/layout/tasks/tasks-registration'
import { CONSENT_DELIVERY_TYPES, PARTICIPANTS_BULK, PERSON_STATES, PROGRESS_STATES } from 'constants/enums'

const getRegistrations = state => get(state,
  'api.tasks.registrationParticipants.list',
  [])


const getBulkType = bulkType => get(bulkType,
  `form.${bulkForm}.values.bulkType`,
  '')

const mapForBulk = (registrations, bulkType) => {
  switch (bulkType) {
    case PROGRESS_STATES.awardRegApproval.id:
      return registrations.filter(r =>
        get(r, 'award.awardLeader', '')
        && !r.isBlocked)
        .map(r => get(r, 'award.id'))

    case PARTICIPANTS_BULK.resendParentalConsent.id:
      return registrations.filter(r =>
        (get(r, 'award.awardState.value') === PROGRESS_STATES.awardRegApproval.id || get(r, 'award.awardState.value') === PROGRESS_STATES.awardRegAssessment.id) &&
        !get(r, 'award.isConsentDeliveryConfirmed') &&
        get(r, 'award.consentDeliveryType.value') === CONSENT_DELIVERY_TYPES.electronically.id
        ).map(r => get(r, 'award.id'))

    case PARTICIPANTS_BULK.resendConfirmationEmail.id:
      return registrations.filter(r =>
              (get(r, 'award.awardState.value') === PROGRESS_STATES.awardRegApproval.id || get(r, 'award.awardState.value') === PROGRESS_STATES.awardRegAssessment.id) &&
               get(r, 'participantPerson.personState.value') === PERSON_STATES.active.id &&
               !get(r, 'participantPerson.isEmailConfirmed')
          ).map(r => get(r, 'award.id'))

    case PARTICIPANTS_BULK.changeParentalConsent.id:
      return registrations.filter(r =>
          (get(r, 'award.awardState.value') === PROGRESS_STATES.awardRegApproval.id || get(r, 'award.awardState.value') === PROGRESS_STATES.awardRegAssessment.id) &&
          get(r, 'participantPerson.personState.value') === PERSON_STATES.active.id &&
          get(r, 'award.consentDeliveryType.value') === CONSENT_DELIVERY_TYPES.paper.id &&
          !get(r, 'award.isConsentDeliveryConfirmed')
      ).map(r => get(r, 'award.id'))

    case PARTICIPANTS_BULK.collectEmails.id:
      return registrations.map(r => get(r, 'award.id'))

    case PARTICIPANTS_BULK.assignLabels.id:
      return registrations.map(r => get(r, 'award.id'))

    case PARTICIPANTS_BULK.unassignLabels.id:
      return registrations.map(r => get(r, 'award.id'))

    case PARTICIPANTS_BULK.assignAwardLabels.id:
      return registrations.map(r => get(r, 'award.id'))

    case PARTICIPANTS_BULK.unassignAwardLabels.id:
      return registrations.map(r => get(r, 'award.id'))

    default:
      return []
  }
}

export default createSelector([getRegistrations, getBulkType],
  mapForBulk)
